import { z } from "zod";

export const ProductSchema = z.object({
  id: z.string(),
  slug: z.string(),
  category: z.string(),
  name: z.string(),
  images: z.array(z.string()),
  description: z.string(),
  content: z.string(),
  currency: z.string(),
  price: z.number(),
  tags: z.array(z.string()),
  url: z.string().url().nullish(),
});

export type Product = z.infer<typeof ProductSchema>;
